<template>
  <transition name="fade" mode="out-in">
    <div @mouseenter="clearTimer" class="toast" v-show="isShowToast">
      <div>
        <p><span>{{dataObj.message || ''}}</span></p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      isShowToast: false,
      data: {},
      dataObj: {},
      onClose: null,
      isClose: false,
      time: null,
    };
  },
  watch: {
    isClose(flage) {
      if (flage) {
        this.isShowToast = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    },
  },
  mounted() {
    this.onClose(this);
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    clearTimer() {
      clearTimeout(this.time);
    },
    close() {
      this.time = setTimeout(() => {
        if (!this.isClose) {
          this.isClose = true;
          this.onClose(this);
        }
      }, 2500);
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  },
};
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  top: 0;
  left: 0;
  z-index: 9999;
  & > div {
    position: absolute;
    top: 50%;
    width: 100%;
    padding: 0 .75rem;
  }
  p {
    width: 100%;
    background-color: rgba(0, 0, 0, .7);
    border-radius: .1rem;
    display: flex;
    justify-content: center;
    padding: .3rem .1rem;
    font-family: PingFangSC-Regular;
    font-size: .3rem;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
